export { WindowTokenModule, WINDOW } from './src/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/ngx-clipboard/dist/~/ngx-window-token/index.js
// module id = ../../../../ngx-clipboard/dist/node_modules/ngx-window-token/index.js
// module chunks = 5